import { useEffect, useState } from "react";
import { useAuthStore, type User } from "../stores";
import { api } from "../utils/api";

export const useAuth = () => {
  const {
    isAuthenticated,
    user,
    login: storeLogin,
    logout: storeLogout,
  } = useAuthStore();

  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const response = await api
        .get("admin/auth/status")
        .json<{ valid: boolean; user?: User }>();

      if (response.valid && response.user) {
        storeLogin(response.user);
      } else {
        storeLogout();
      }
    } catch {
      storeLogout();
    } finally {
      setLoading(false);
    }
  };

  const login = async (userData: User) => {
    storeLogin(userData);
  };

  const logout = async () => {
    try {
      await api.post("admin/logout");
    } catch (error) {
      console.error("Logout error:", error);
    }
    storeLogout();
  };

  return {
    isAuthenticated,
    user,
    loading,
    login,
    logout,
    checkAuth,
  };
};
